import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import useModal from '../../hooks/useModal'

import * as S from './Modal.styles'
import { CompleteBtn } from '../Buttons'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'

export default function SelectReportTypeModal(props) {
  const { closeModal } = useModal()
  const [reportTypeId, setReportTypeId] = useState(props.reportTypeList[0].reportTypeId)
  const navigate = useNavigate()

  return (
    <>
      <S.Background/>
      <S.ModalBox width='350px' height='300px'>
        <S.ModalContents width='75%'>
          <S.Title>리포트 유형 선택</S.Title>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              defaultValue={props.reportTypeList[0].reportTypeId}
              onChange={(e) => setReportTypeId(e.target.value)}
            >
              {
                props.reportTypeList.map(reportType => (
                  <FormControlLabel
                    label={reportType.reportTypeNameEn}
                    value={reportType.reportTypeId}
                    control={<Radio />}
                  />
                ))
              }
            </RadioGroup>
          </FormControl>
          <CompleteBtn
            width='100%'
            height='40px'
            margin='20px 0 0 10px'
            fontSize='1em'
            onClick={() => {
              navigate(`main/report/write?reportTypeId=${reportTypeId}&date=${props.date}`)
              closeModal()
            }}
          >확인
          </CompleteBtn>
        </S.ModalContents>
      </S.ModalBox>
    </>
  )
}